import "core-js/modules/es.array.includes.js";
export let ControlledTagKey = /*#__PURE__*/function (ControlledTagKey) {
  ControlledTagKey["AppLink"] = "appLink";
  ControlledTagKey["Canonical"] = "canonical";
  ControlledTagKey["DeepLinkAndroid"] = "al:android:url";
  ControlledTagKey["DeepLinkIOS"] = "al:ios:url";
  ControlledTagKey["Description"] = "description";
  ControlledTagKey["Facebook"] = "facebook";
  ControlledTagKey["Keywords"] = "keywords";
  ControlledTagKey["NewsKeywords"] = "news_keywords";
  ControlledTagKey["Title"] = "title";
  ControlledTagKey["Twitter"] = "twitter";
  return ControlledTagKey;
}({});
export const isControlledTagKey = key => Object.values(ControlledTagKey).includes(key);